import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "veevaLoaderContainer"
};
const _hoisted_2 = {
  key: 0,
  class: "loadingContent"
};
const _hoisted_3 = {
  class: "loadingTitle"
};
const _hoisted_4 = {
  class: "loadingMessage"
};
const _hoisted_5 = {
  class: "loadingStatus"
};
const _hoisted_6 = {
  key: 1,
  class: "errorContent"
};
const _hoisted_7 = {
  class: "errorIcon"
};
const _hoisted_8 = {
  class: "errorMessage"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = _resolveComponent("loader");
  const _component_icon = _resolveComponent("icon");
  const _component_standard_button = _resolveComponent("standard-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!_ctx.hasError ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_loader, {
    "spinner-size": "spinnersNormal",
    "spinner-color": "darkSpinner"
  }), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('veeva.loading.title')), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('veeva.loading.message')), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.statusMessage), 1)])) : _createCommentVNode("", true), _ctx.hasError ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_icon, {
    icon: "alert-circle-outline",
    size: "large",
    color: "danger"
  })]), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1), _createVNode(_component_standard_button, {
    onAction: _ctx.startDownload,
    type: "primary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('veeva.loading.retry')), 1)]),
    _: 1
  }, 8, ["onAction"])])) : _createCommentVNode("", true)]);
}